import ResourcesCard from './resources';

export default ResourcesCard;
